import GLightbox from 'glightbox';
import '@lottiefiles/dotlottie-wc';

/**
 * Alpine
 */
import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
import User from './../../../../plugins/webikon-loopia-generic-platform-integration/assets/public/js/wlgpi-user';
import Cart from './../../../../plugins/webikon-loopia-generic-platform-integration/assets/public/js/wlgpi-cart';
import PackageAddons from './components/package-addons';
import MacalyAiPackages from './blocks/macaly-ai-packages';

Alpine.plugin(collapse);
window.Alpine = Alpine;
Alpine.store('popup', '');
Alpine.store('isLogged', false);
Alpine.store('cart', new Cart());
Alpine.store('user', new User());

// Register Alpine.js components
Alpine.data('PackageAddons', PackageAddons);
Alpine.data('MacalyAiPackages', MacalyAiPackages);

// Import megamenu before Alpine starts
import './components/megamenu';

Alpine.start();

/**
 * Import components
 */
import SearchInput from './components/search-input';
import BlogHeroSlider from './components/blog-hero-slider';
import './components/tooltip';
import './components/anchored-nav';
import './components/configurator';
import './components/slider';
import './components/custom-select';

import ScrollThroughBlock from './blocks/scroll-through-block';
import ProductBenefitsExpressiveBlock from './blocks/product-benefits-expressive-block';
import CarouselFront from './blocks/carousel';
import DomainPriceList from './blocks/domain-price-table';
import PackageCardCredits from './blocks/package-card-credits';
import './blocks/jobs-list';
import './blocks/content-form-block';
import './blocks/easy-cookie-scanner-block';

import './misc/cookies';
import './misc/gravity-forms';

/**
 * app.main
 */
document.addEventListener('DOMContentLoaded', () => {
  GLightbox({
    selector: '.glightbox',
    touchNavigation: true,
    loop: true,
    autoplayVideos: true,
  });

  // sections

  // blocks
  new CarouselFront();
  new ScrollThroughBlock();
  new ProductBenefitsExpressiveBlock();
  new DomainPriceList();
  new PackageCardCredits();
  // components
  new SearchInput();
  new BlogHeroSlider();

  // partials

  // misc

  // application code
});

// Register static assets
import.meta.glob(['../images/**', '../fonts/**']);
